<template>
  <div
    class="app-tile"
    :class="{
      'app-tile_disabled': props.disabled,
    }"
  >
    <router-link
      :to="props.route"
      class="app-tile__link"
      :style="`--border-color: ${props.borderColor};`"
    >
      <div class="app-tile__content">
        <component
          :is="props.icon"
          v-if="typeof props.icon !== 'string'"
          class="app-tile__content-icon"
        />
        <i
          v-else
          class="app-tile__content-icon"
          :class="props.icon"
        />

        <div class="app-tile__content-text">
          <span
            class="typo-font-3 app-tile__title"
          >
            {{ props.title }}
          </span>

          <small v-if="!isNullish(props.subtitle)">
            {{ props.subtitle }}
          </small>
        </div>

        <slot name="actions" />
      </div>
    </router-link>
  </div>
</template>

<script lang="ts" setup>

import {
  CSSProperties,
} from 'vue';
import {
  RouteLocationRaw,
} from 'vue-router';

import type {
  TIcon,
} from '../../types/icon.ts';
import {
  isNullish,
} from '../../utils/common';

export type TAppTileProps = {
  route: RouteLocationRaw,
  title: string,
  subtitle?: string,
  icon: TIcon,
  borderColor: CSSProperties['color'],
  disabled?: boolean,
};

const props = defineProps<TAppTileProps>();
</script>

<style lang="scss" scoped>
.app-tile {
  --border-color: var(--border-color-subtle);

  position: relative;
  width: 100%;
  height: 3.875rem;
  border-radius: var(--border-radius-small);
  overflow: hidden;
  border: 1px solid var(--border-color-subtle);
  background-color: var(--surface-card);
  display: flex;
  justify-content: space-between;

  &_disabled {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.5;
  }

  &__link {
    display: flex;
    padding: var(--gap);
    justify-content: space-between;
    border-left: 0.75rem solid var(--border-color);
    flex-grow: 1;
    text-decoration: none;
    color: var(--text-color)
  }

  &__pin-button {
    padding: var(--gap);
    color: var(--text-color-secondary);
  }

  &__content {
    height: 100%;
    display: flex;
    align-items: center;
    gap: var(--gap-union);
  }

  &__content-icon {
    width: 1.875rem;
    height: 1.875rem;
    font-size: 1.875rem;
    line-height: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--text-color);
  }

  &__content-text {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    small {
      color: var(--color-text-secondary)
    }
  }

  &__title {
    font-family: var(--font-family-heading);
    font-synthesis-weight: none;
  }

  &__pin-icon {
    width: 1.25rem;
    height: 1.25rem;
  }
}
</style>
